var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntellijIdea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2702_618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.6 399.2L5.6001 301.6L67.2001 187.2L244 256L129.6 399.2Z",
    fill: "url(#paint0_linear_2702_618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 136.8L502.4 432.8L305.6 512L187.2 435.2L360 256L284.8 89.6L352.8 8L512 136.8Z",
    fill: "url(#paint1_linear_2702_618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 136.8L356 320.8L284.8 89.6L352.8 8L512 136.8Z",
    fill: "url(#paint2_linear_2702_618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.4 424.8L41.6 499.2L74.4 384L116.8 241.6L0 202.4L74.4 0L234.4 19.2L392.8 200L246.4 424.8Z",
    fill: "url(#paint3_linear_2702_618)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416 96H96V416H416V96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.4 356H246.4V376H126.4V356ZM212 161.6V137.6H146.4V161.6H164.8V245.6H146.4V270.4H212V245.6H193.6V161.6H212ZM276 272C266.867 272.412 257.779 270.484 249.6 266.4C242.908 262.708 236.944 257.828 232 252L250.4 231.2C253.722 234.85 257.484 238.075 261.6 240.8C265.472 243.07 269.915 244.181 274.4 244C279.332 244.377 284.129 242.278 287.2 238.4C290.905 233.628 292.625 227.609 292 221.6V136H321.6V222.4C321.903 229.476 320.816 236.543 318.4 243.2C316.289 249.954 312.424 256.027 307.2 260.8C298.133 267.531 287.277 271.428 276 272Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2702_618",
    x1: 5.6001,
    y1: 293.2,
    x2: 243.52,
    y2: 293.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F97A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B07B58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#577BAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E7CE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2702_618",
    x1: 188.32,
    y1: 182.08,
    x2: 608.504,
    y2: 278.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#CB7A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#9E7B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#757B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#537BB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#387CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#237CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#147CEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0B7CF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2702_618",
    x1: 462.4,
    y1: 313.76,
    x2: 283.45,
    y2: 31.5007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE315D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CB417E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#9E4E9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#755BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5365CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#386DDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2374E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#1478F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0B7BF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2702_618",
    x1: 78.56,
    y1: 120.24,
    x2: 509.437,
    y2: 561.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE315D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F63462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#DF3A71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C24383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#AD4A91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#755BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#1D76ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2702_618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntellijIdea);
export default __webpack_public_path__ + "static/media/intellij-idea.a665ae5920b20b5c309de0aa306924d5.svg";
export { ForwardRef as ReactComponent };